<h1>Sign Up</h1>

<div class="card">
  <form (ngSubmit)="submit()" #signupForm="ngForm">
    <label for="first_name">First Name</label>
    <input id="first_name" name="first_name" type="text" required [(ngModel)]="firstName" />

    <label for="last_name">Last Name</label>
    <input id="last_name" name="last_name" type="text" required [(ngModel)]="lastName" />

    <label for="email">Email</label>
    <input id="email" name="email" type="email" required [(ngModel)]="email" />

    <label for="phone">Phone</label>
    <input id="phone" name="phone" type="text" inputmode="tel" [(ngModel)]="phone" />
    <p class="muted form-hint">Allowed: digits, spaces, parentheses, hyphens, and optional leading +.</p>

    <label for="password">Password</label>
    <input id="password" name="password" type="password" required [(ngModel)]="password" />
    <p class="muted form-hint">Use at least 8 characters with uppercase, lowercase, a number, and a special character.</p>

    <button type="submit" [disabled]="loading">{{ loading ? 'Creating...' : 'Create Account' }}</button>

    <p class="error" *ngIf="errorMessage">{{ errorMessage }}</p>
    <p class="muted" *ngIf="successMessage">{{ successMessage }}</p>
    <p class="muted">Already have an account? <a routerLink="/sign-in">Sign in</a></p>
  </form>
</div>
